import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

import { Keyword } from 'ish-core/models/keyword/keyword.model';
import { HighlightPipe } from 'ish-core/pipes/highlight.pipe';

@Component({
  selector: 'ish-suggest-keywords',
  imports: [CommonModule, HighlightPipe, TranslatePipe],
  templateUrl: './suggest-keywords.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestKeywordsComponent {
  readonly keywords = input<Keyword[]>(undefined);
  readonly maxAutoSuggests = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly submitSearch = output<string>();

  submit(term: string) {
    this.submitSearch.emit(term);
  }
}
